import { useInView } from 'framer-motion'
import { useRef } from 'react'

export const useDashboardInView = () => {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, margin: '200px 0px' })
  return { ref, isInView }
}
